import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import { GUEST_CONFIRMATION_BUTTON } from 'bento-ordering/group_ordering/constants/groupOrder';

import {
  selectCartGroupOrderCartClosed,
  selectIsGroupOrderCurrentDinerDoneOrdering,
  selectCartGroupOrderSlug,
  selectGroupOrderErrorIs404,
  selectGroupOrderErrorIs1006
} from 'bento-ordering/cart/selectors/index';
import GroupOrderOrderConfirmedSnackbar from 'bento-ordering/group_ordering/components/GroupOrderOrderConfirmedSnackbar';
import GroupOrderErrorToast from 'bento-ordering/group_ordering/components/GroupOrderErrorToast';
import { confirmOrderItems } from 'bento-ordering/group_ordering/actions/index';
import { useRedirectToOOMenu } from 'bento-ordering/group_ordering/hooks';

const GroupOrderDinerFooter = () => {
  const isCartClosed = useSelector(selectCartGroupOrderCartClosed);
  const isDinerDoneOrdering = useSelector(
    selectIsGroupOrderCurrentDinerDoneOrdering
  );
  const errorIs404NotFound = useSelector(selectGroupOrderErrorIs404);
  const errorIs1006WSAbnormalClosure = useSelector(selectGroupOrderErrorIs1006);
  const groupOrderSlug = useSelector(selectCartGroupOrderSlug);

  const dispatch = useDispatch();

  const redirectToOO = useRedirectToOOMenu();

  const handleConfirmOrder = () => {
    dispatch(confirmOrderItems(groupOrderSlug));
  };

  const handlePrimaryCtaClick = () => {
    if (errorIs404NotFound) {
      redirectToOO();
      return;
    }
    if (errorIs1006WSAbnormalClosure) {
      window.location.reload(true);
      return;
    }
    handleConfirmOrder();
  };

  const getCheckoutButtonLabel = () => {
    if (errorIs404NotFound) {
      return GUEST_CONFIRMATION_BUTTON.error;
    } else if (errorIs1006WSAbnormalClosure) {
      return GUEST_CONFIRMATION_BUTTON.retry;
    }
    return GUEST_CONFIRMATION_BUTTON.primary;
  };

  return (
    <>
      {isCartClosed || isDinerDoneOrdering ? (
        <GroupOrderOrderConfirmedSnackbar isCart={true} />
      ) : (
        <>
          <GroupOrderErrorToast />
          <PrimaryCta
            component="a"
            handleClick={handlePrimaryCtaClick}
            label={getCheckoutButtonLabel()}
            fullWidth
          />
        </>
      )}
    </>
  );
};

export default GroupOrderDinerFooter;
